import { RequireFeatureFlagsPage } from "./authentication";
import { NotFound } from "components/notFound";
import { PeakShavingPage } from "components/scenarioPlanning/peakShaving/PeakShavingPage";

import { Route, Routes } from "react-router";

export const PlanningRoutes = () => {
  return (
    <Routes>
      <Route
        path="/peak-shaving"
        element={
          <RequireFeatureFlagsPage featureFlags={["peak_shaving_scenarios"]}>
            <PeakShavingPage />
          </RequireFeatureFlagsPage>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
